// src/components/Seo.js
import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async'
export default function Seo({title, description, type, image_link, keywords}) {
return (
<HelmetProvider>
  <Helmet>
  { /* Standard metadata tags */ }
    <title>{title}</title>
    <meta name='description' content={description} />
    <meta name="keywords" content={keywords} />
  { /* End standard metadata tags */ }
  { /* Facebook tags */ }
    <meta property="og:type" content={type} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image_link} />
  { /* End Facebook tags */ }
  { /* Twitter tags */ }
    <meta name="twitter:card" content={type} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image_link} />
  { /* End Twitter tags */ }
  </Helmet>
</HelmetProvider>
)
}